import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Container, Divider, Stack } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import { StarSolidIcon } from '@fiverr-private/visuals';
import { AggregatedRatingProps } from './AggregatedRating.types';
import { formatRating, formatReviewsWithApprox } from './helpers/AggregatedRating.helpers';
import { AggregatedRatingTooltip } from './AggregatedRatingTooltip';

const STARS_COUNT = 5;

export const AggregatedRating = ({ aggregatedRating, elementProps }: AggregatedRatingProps) => {
  const { locale } = getContext();
  const { rating, count } = aggregatedRating;
  const roundedRating = formatRating(rating, locale);
  const formattedCount = formatReviewsWithApprox(count, locale);
  const reviewsText = translate('seo_content.aggregated_rating.approx_reviews', {
    params: { count: formattedCount },
  });

  return (
    <Stack
      width="100%"
      direction={{ sm: 'row', default: 'column' }}
      columnGap="1"
      rowGap="2"
      paddingX={{ sm: '6', default: '4' }}
      paddingY="4"
      backgroundColor="grey_100"
      borderWidth="sm"
      borderColor="grey_400"
      borderStyle="solid"
      borderRadius="lg"
      data-testid="rating-wrapper"
      {...elementProps}
    >
      <Stack columnGap={{ sm: '1', default: '2' }}>
        <Stack columnGap="1" paddingTop="0.5" alignItems="center">
          {Array.from({ length: STARS_COUNT }).map((_, index) => (
            <Box key={index}>
              <StarSolidIcon color="grey_1200" size="sm" />
            </Box>
          ))}
        </Stack>
        <Text color="bodyPrimary" fontWeight="bold" alignSelf="center">
          {roundedRating}/5
        </Text>
      </Stack>
      <Container display={{ sm: 'block', default: 'none' }}>
        <Divider direction="vertical" marginX="5" borderColor="border" borderWidth="sm" />
      </Container>
      <Text color="bodyPrimary">
        {reviewsText}
        <AggregatedRatingTooltip />
      </Text>
    </Stack>
  );
};
